import { snakeCaseToTitleCase } from '@utils/stringFormat';

import { METHOD_LABEL_OVERRIDES, TransactionStatus } from '../constants';

export const getPaymentModeLabel = (
  paymentMethod: string | null | undefined
) => {
  const method = paymentMethod?.trim() ?? '';
  if (method === '') return '';
  return METHOD_LABEL_OVERRIDES[method] ?? snakeCaseToTitleCase(method);
};

/** Human-readable payment channel (offline / online), single line. */
export const getPaymentChannelDescription = (payment_mode: string) => {
  if (payment_mode === 'manual') {
    return 'Paid Offline';
  }
  if (payment_mode === 'automatic') {
    return 'Paid via Cofee';
  }
  return '';
};

export const getPaymentStatusDisplayText = (
  status: TransactionStatus,
  payment_mode: string
) => {
  if (status === TransactionStatus.TO_SETTLE) return 'Processing';
  if (status === TransactionStatus.SETTLED) {
    return getPaymentChannelDescription(payment_mode);
  }
  if (status === TransactionStatus.PROCCESSING) return 'Pending';
  return '';
};
